webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(66),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container_index_Index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container_index_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__container_index_Index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Resume',
  components: {
    'index-component': __WEBPACK_IMPORTED_MODULE_0__container_index_Index_vue___default.a
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StarryBg_StarryBg_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StarryBg_StarryBg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StarryBg_StarryBg_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Cover_Cover_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Cover_Cover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Cover_Cover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Skills_Skills_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Skills_Skills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Skills_Skills_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutMe_AboutMe_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutMe_AboutMe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AboutMe_AboutMe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Works_Works_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Works_Works_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Works_Works_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Planet_Planet_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Planet_Planet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Planet_Planet_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  components: {
    'starry-bg': __WEBPACK_IMPORTED_MODULE_0__components_StarryBg_StarryBg_vue___default.a,
    'planet': __WEBPACK_IMPORTED_MODULE_5__components_Planet_Planet_vue___default.a,
    'svg-cover': __WEBPACK_IMPORTED_MODULE_1__components_Cover_Cover_vue___default.a,
    'skill-detail': __WEBPACK_IMPORTED_MODULE_2__components_Skills_Skills_vue___default.a,
    'aboutme-detail': __WEBPACK_IMPORTED_MODULE_3__components_AboutMe_AboutMe_vue___default.a,
    'works-detail': __WEBPACK_IMPORTED_MODULE_4__components_Works_Works_vue___default.a
  },
  data: function data() {
    return {
      cover_mount: true,
      planet_open: false,
      planetBoxHeight: false,
      initInnerHeight: false,
      planet_datas: [{
        name_en: "Skills",
        name_zh: "技能",
        color_planet: "#d12c2c",
        color_planet_shadow: "#791313",
        color_name: "#5edafd"
      }, {
        name_en: "Works",
        name_zh: "作品集",
        color_planet: "#1D71B8",
        color_planet_shadow: "#134a79",
        color_name: "#5edafd"
      }, {
        name_en: "About Me",
        name_zh: "關於我",
        color_planet: "#179013",
        color_planet_shadow: "#127020",
        color_name: "#5edafd"
      }]
    };
  },
  mounted: function mounted() {
    this.initInnerHeight = 'height: ' + window.innerHeight;
  },

  methods: {
    unmountCover: function unmountCover() {
      this.cover_mount = false;
    },
    openPlanet: function openPlanet(planet_name) {
      this.planet_open = planet_name;
    },
    closePlanet: function closePlanet() {
      this.planet_open = false;
    },
    updatePlanetBoxHeight: function updatePlanetBoxHeight(height) {
      this.planetBoxHeight = height;
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);



var tl__detail = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutMe',
  props: {
    planetOpen: Boolean,
    planetColor: String
  },
  watch: {
    planetOpen: function planetOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!newValue) {
          this.animationOut();
        }
      }
    }
  },
  updated: function updated() {
    if (this.planetOpen) {
      this.extendBoxHeight();
      this.animationIn();
    }
  },
  beforeDestroy: function beforeDestroy() {
    tl__detail.kill();
  },

  methods: {
    extendBoxHeight: function extendBoxHeight() {
      var boxHeight = this.$el.offsetHeight;
      if (boxHeight > window.innerHeight) {
        this.$emit('updatePlanetBoxHeight', boxHeight + 'px');
      }
    },
    animationIn: function animationIn() {
      var h2 = this.$el.querySelector('h2');
      var h3 = this.$el.querySelectorAll('h3');
      var p = this.$el.querySelectorAll('p');
      tl__detail = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({
        onReverseComplete: this.scrollTop
      }).fromTo(h2, 0.8, {
        rotationX: '-90'
      }, {
        rotationX: 0
      }).fromTo(h3, 0.5, {
        opacity: 0,
        x: -50
      }, {
        opacity: 1,
        x: 0
      }, 0.5, '-=0.2').staggerFromTo(p, 0.5, {
        opacity: 0,
        x: -50
      }, {
        opacity: 1,
        x: 0
      }, 0.2);
    },
    animationOut: function animationOut() {
      tl__detail.timeScale(10).reverse();
    },
    scrollTop: function scrollTop() {
      if (this.$el.offsetHeight > window.innerHeight) {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(window, 0.1, {
          scrollTo: 0,
          onComplete: this.resetPlantBoxHeight
        });
      } else {
        this.resetPlantBoxHeight();
      }
    },
    resetPlantBoxHeight: function resetPlantBoxHeight() {
      this.$emit('updatePlanetBoxHeight', '100vh');
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_ShipWindow_ShipWindow__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_ShipWindow_ShipWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_ShipWindow_ShipWindow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_Man_Man__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_Man_Man___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_Man_Man__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_Computer_Computer_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_Computer_Computer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_Computer_Computer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);


;




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cover',
  components: {
    'svg-window': __WEBPACK_IMPORTED_MODULE_0__svg_ShipWindow_ShipWindow___default.a,
    'svg-man': __WEBPACK_IMPORTED_MODULE_1__svg_Man_Man___default.a,
    'svg-computer': __WEBPACK_IMPORTED_MODULE_2__svg_Computer_Computer_vue___default.a
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      shockSwitch: false,
      flyFSwtich: false
    };
  },

  methods: {
    getShockAniamtion: function getShockAniamtion() {
      this.shockSwitch = true;
    },
    makeTitleFly: function makeTitleFly() {
      this.flyFSwtich = true;
    },
    zoomInAnimation: function zoomInAnimation() {
      var _this = this;

      var cover = this.$el;
      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(cover, 1.5, {
        scale: 7,
        force3D: false,
        ease: Power1.easeOut,
        onComplete: function onComplete() {
          _this.$emit('unmountCover');
        }
      });
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Computer'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Man',
  data: function data() {
    return {
      ani_dig: false,
      ani_shock: false,
      ani_stepBack: false
    };
  },
  mounted: function mounted() {
    var eye_w__man = this.$el.getElementById('eye_w__man');
    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set(eye_w__man, {
      transformOrigin: "center center",
      rotation: 60
    });
    this.digNoseAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    this.ani_dig.kill();
  },

  props: {
    shockSwitch: Boolean
  },
  watch: {
    shockSwitch: function shockSwitch(newValue, oldValue) {
      if (newValue === true) {
        this.getShockAniamtion();
      }
    }
  },
  methods: {
    digNoseAnimation: function digNoseAnimation() {
      var g_dig = this.$el.getElementById('g__dig');
      this.ani_dig = __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(g_dig, 1.5, {
        x: '-10%',
        repeat: -1,
        yoyo: true,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeInOut
      });
    },
    getShockAniamtion: function getShockAniamtion() {
      var _this = this;

      this.ani_dig.kill();
      var man = this.$el;
      var eye_ball = this.$el.querySelector('#eye_ball__man');
      var nose_and_hand = this.$el.querySelector('#g__nose_and_hand');
      var blood = this.$el.querySelector('#blood');
      this.ani_shock = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]().to(man, 0.1, {
        y: -35,
        repeat: 1,
        yoyo: true,
        ease: Bounce
      }).to(nose_and_hand, 0.1, {
        y: -37,
        repeat: 1,
        yoyo: true,
        ease: Bounce
      }, '-0.1').to(eye_ball, 2.7, {
        delay: 1,
        x: -8,
        y: 20
      }).to(blood, 1, {
        y: 20
      }).to(man, 1.7, {
        delay: 0.5,
        x: '-=35%',
        y: 20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }).to(man, 1.5, {
        delay: 0.2,
        y: 40,
        x: '-=35%',
        onComplete: function onComplete() {
          _this.$emit('makeTitleFly');
        }
      });
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Window',
  mounted: function mounted() {},

  props: {
    flyFSwtich: Boolean
  },
  watch: {
    flyFSwtich: function flyFSwtich(newValue, oldValue) {
      if (newValue === true) {
        this.flyF2EAnimation();
      }
    }
  },
  methods: {
    shakeNameplate: function shakeNameplate() {
      var _this = this;

      var nameplate = this.$el.getElementById('g_nameplate');
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(nameplate, 0.5, {
        rotation: 720,
        scale: 1.5,
        yoyo: true,
        repeat: 1,
        transformOrigin: "center center",
        onComplete: function onComplete() {
          _this.$emit('getShock');
        }
      });
    },
    flyF2EAnimation: function flyF2EAnimation() {
      var _this2 = this;

      var window_radious = 100,
          viewBox_size = 500;

      var text_f2e__path = this.$el.getElementById('text_f2e__path');
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(text_f2e__path, 2, {
        attr: {
          d: '\n      M' + (viewBox_size / 2 - window_radious - 148) + ',100\n      a' + (window_radious + 300) + ',' + 0 + ' \n      0 1 1 \n      ' + (2 * window_radious + 300) + ',0\n      '
        },
        ease: Power1.easeInOut,
        onComplete: function onComplete() {
          _this2.$emit('zoomIn');
        }
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_detect__);





var md = new __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default.a(window.navigator.userAgent);
var windowInnerHeightWithAddressBar = md.mobile() ? window.innerHeight : false;

var zoomLock = false;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Planet',
  data: function data() {
    return {
      tl_ring: new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"](),
      planet_offsetLeft: 0,
      planet_offsetTop: 0,
      tl_zoom: false
    };
  },

  props: {
    name_en: String,
    name_zh: String,
    color_planet: String,
    color_planet_shadow: String,
    color_name: String,
    planetOpen: [String, Boolean],
    planetIndex: Number
  },
  watch: {
    planetOpen: function planetOpen(newVal, oldVal) {
      if (oldVal == this.name_en && newVal == false) {
        this.zoomOutPlanet();
      }
    }
  },
  mounted: function mounted() {
    this.getPlanetOffset();
    window.addEventListener('resize', this.getPlanetOffset);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.getPlanetOffset);
  },

  computed: {
    color_planet_style: function color_planet_style() {
      return 'fill: ' + this.color_planet;
    },
    color_planet_shadow_style: function color_planet_shadow_style() {
      return 'fill: ' + this.color_planet_shadow;
    }
  },
  methods: {
    getPlanetOffset: function getPlanetOffset() {
      var planet = this.$el;
      if (window.innerWidth >= window.innerHeight) {
        this.planet_offsetLeft = -(this.planetIndex - 1) * (window.innerWidth * 0.15 + 100);
        this.planet_offsetTop = 0;
      } else {
        if (!this.planetOpen) {
          this.planet_offsetTop = (this.planetIndex - 1) * window.innerHeight * 0.23;
          console.log(this.planet_offsetTop);
          this.planet_offsetLeft = 0;
        }
      }
    },
    zoomInCheck: function zoomInCheck() {
      if (zoomLock) {
        return false;
      } else {
        zoomLock = true;
        this.zoomInPlaent();
      }
    },
    zoomInPlaent: function zoomInPlaent() {
      var _this = this;

      var planet = this.$el.querySelector(".planet");
      var title = this.$el.querySelector(".text__title");
      var cloud = this.$el.querySelectorAll(".cloud");
      var x, y;

      if (window.innerWidth >= window.innerHeight) {
        x = this.planet_offsetLeft;
        y = 1250 - window.innerHeight / 2;
      } else {
        x = false;
        y = (windowInnerHeightWithAddressBar || window.innerHeight) * 1.21 - this.planet_offsetTop;
        console.log(y);
      }

      this.tl_zoom = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]().set(this.$el, {
        zIndex: 1
      }).to(planet, 0.5, {
        force3D: false,
        scale: 1,
        x: x,
        y: y,
        transformOrigin: "center center",
        ease: Power4.easeIn
      }).to(title, 0.5, {
        opacity: 1,
        force3D: false,
        attr: {
          startOffset: '25%'
        },
        onComplete: function onComplete() {
          _this.$emit("openPlanet", _this.name_en);
        }
      }).to(cloud, 0.1, {
        opacity: 0,
        onReverseComplete: function onReverseComplete() {
          zoomLock = false;
        }
      });
    },
    zoomOutPlanet: function zoomOutPlanet() {
      this.tl_zoom.reverse();
    },
    hoverEnter: function hoverEnter() {
      var ring = this.$el.querySelector('.ring');
      if (window.innerWidth >= window.innerHeight) {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(ring, 0.5, {
          scale: 0.9,
          rotation: '+=45',
          force3D: false,
          ease: Bounce.easeOut,
          onComplete: rotate
        });
      }

      function rotate() {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(ring, 20, {
          rotation: '+=360',
          repeat: -1,
          ease: Power0.easeNone
        });
      }
    },
    hoverLeave: function hoverLeave() {
      if (window.innerWidth >= window.innerHeight) {
        var ring = this.$el.querySelector('.ring');
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(ring, 0.5, {
          scale: 0.4,
          rotation: "+=90"
        });
      }
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);



var tl__detail = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Skills',
  props: {
    planetOpen: Boolean,
    planetColor: String
  },
  watch: {
    planetOpen: function planetOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!newValue) {
          this.animationOut();
        }
      }
    }
  },
  updated: function updated() {
    if (this.planetOpen) {
      this.extendBoxHeight();
      this.animationIn();
    }
  },
  beforeDestroy: function beforeDestroy() {
    tl__detail.kill();
  },

  methods: {
    extendBoxHeight: function extendBoxHeight() {
      var boxHeight = this.$el.offsetHeight;
      if (boxHeight > window.innerHeight) {
        this.$emit('updatePlanetBoxHeight', boxHeight + 'px');
      }
    },
    animationIn: function animationIn() {
      var h3 = this.$el.querySelectorAll('h3');
      var p = this.$el.querySelectorAll('p');
      tl__detail = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({
        onReverseComplete: this.scrollTop
      }).staggerFromTo(h3, 0.8, {
        delay: 10,
        opacity: 0,
        x: -50
      }, {
        opacity: 1,
        x: 0
      }, 0.2).staggerFromTo(p, 0.5, {
        opacity: 0,
        x: -50
      }, {
        opacity: 1,
        x: 0
      }, 0.2, '-=0.5');
    },
    animationOut: function animationOut() {
      tl__detail.timeScale(10).reverse();
    },
    scrollTop: function scrollTop() {
      if (this.$el.offsetHeight > window.innerHeight) {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(window, 0.1, {
          scrollTo: 0,
          onComplete: this.resetPlantBoxHeight
        });
      } else {
        this.resetPlantBoxHeight();
      }
    },
    resetPlantBoxHeight: function resetPlantBoxHeight() {
      this.$emit('updatePlanetBoxHeight', '100vh');
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StarryBG'
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin__);




var tl__detail = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Works',
  props: {
    planetOpen: Boolean,
    planetColor: String
  },
  data: function data() {
    return {
      works: [{
        name: 'Stories Kingdom',
        link: 'https://github.com/GoreStarry/Stories_Kingdom',
        technologies: 'React,Express, Mongo, Mongoose, Draft.js, Webpack, Nightwatch, Chai, Sinon',
        description: '針對中文直式文章書寫排版需求，以及重現翻頁文韻所開發的線上編輯平台'
      }, {
        name: 'Nuns on the run',
        link: 'https://github.com/GoreStarry/nuns_on_the_run',
        technologies: 'React, Express, Mongo, Socket.io, Canvas',
        description: '將桌遊轉成再投影機上即時顯示所有玩家手機輸入的移動操作，玩家並可用手機拍出套上修女造型的照片。'
      }, {
        name: 'Mind Test VR',
        link: 'https://www.youtube.com/watch?v=Pxxw_ZY2nf8',
        technologies: 'A-Frame, Vue.js, TheaterJS',
        description: 'WebVR的中文演出相關研究開發。'
      }, {
        name: 'CodePen',
        link: 'http://codepen.io/GoreWang/',
        technologies: 'SCSS, SVG, PUG, GSAP...',
        description: '視覺刻版相關習作'
      }, {
        name: '韋氏中醫（中國）',
        link: 'http://www.weis-cmg.com/',
        technologies: 'AngularJS(1), Gulp, Django...',
        description: '形象官網製作'
      }, {
        name: 'Remiel',
        link: 'https://github.com/GoreStarry/Remiel_github',
        technologies: 'jQuery, Gulp, SASS...',
        description: '中文直式翻頁，自寫自繪自做的線上圖文展演平台'
      }, {
        name: '愛在轉角新版（尚未上線）',
        link: false,
        technologies: 'React, i18n, Socket.IO, Canvas, WebVR, Webpack, Google map(Geo) , 百度地圖, Velocity...',
        description: '聊天室,雷達動態,照片牆,緣份地圖...'
      }, {
        name: '愛在轉角(舊) - 愛在發聲',
        link: 'https://www.l-somewhere.com/graffiti/',
        technologies: 'AngularJS(1), Django...',
        description: '具有私下連結性的討論版...'
      }, {
        name: '易賾商城',
        link: false,
        technologies: 'React, Django...',
        description: '中國單品銷售商城'
      }, {
        name: 'Resume 2015',
        link: 'https://gorestarry.github.io/Resume-2015/',
        technologies: 'jQuery, Canvas, Gulp, SASS...',
        description: '2015前相關前端作品...'
      }]
    };
  },

  watch: {
    planetOpen: function planetOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!newValue) {
          this.animationOut();
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    tl__detail.kill();
  },
  updated: function updated() {
    if (this.planetOpen) {
      this.extendBoxHeight();
      this.animationIn();
    }
  },

  methods: {
    extendBoxHeight: function extendBoxHeight() {
      var boxHeight = this.$el.offsetHeight;
      if (boxHeight > window.innerHeight) {
        this.$emit('updatePlanetBoxHeight', boxHeight + 'px');
      }
    },
    animationIn: function animationIn() {
      var box__work = this.$el.querySelectorAll('.box__work');

      tl__detail = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({
        onReverseComplete: this.scrollTop
      }).staggerFromTo(box__work, 0.4, {
        opacity: 0,
        y: 30
      }, {
        opacity: 1,
        y: 0
      }, 0.2);
    },
    animationOut: function animationOut() {
      tl__detail.timeScale(5).reverse();
    },
    scrollTop: function scrollTop() {
      if (this.$el.offsetHeight > window.innerHeight) {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(window, 0.1, {
          scrollTo: 0,
          onComplete: this.resetPlantBoxHeight
        });
      } else {
        this.resetPlantBoxHeight();
      }
    },
    resetPlantBoxHeight: function resetPlantBoxHeight() {
      this.$emit('updatePlanetBoxHeight', '100vh');
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Resume_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Resume_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Resume_vue__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',

  template: '<Resume/>',
  components: {
    Resume: __WEBPACK_IMPORTED_MODULE_2__Resume_vue___default.a
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+ZW52ZWxvcDwvdGl0bGU+CjxzdHlsZT4Kc3ZnewogIGZpbGw6IHdoaXRlOwp9Cjwvc3R5bGU+CjxwYXRoIGQ9Ik0yOSA0aC0yNmMtMS42NSAwLTMgMS4zNS0zIDN2MjBjMCAxLjY1IDEuMzUgMyAzIDNoMjZjMS42NSAwIDMtMS4zNSAzLTN2LTIwYzAtMS42NS0xLjM1LTMtMy0zek0xMi40NjEgMTcuMTk5bC04LjQ2MSA2LjU5di0xNS42NzZsOC40NjEgOS4wODZ6TTUuNTEyIDhoMjAuOTc2bC0xMC40ODggNy44NzUtMTAuNDg4LTcuODc1ek0xMi43OSAxNy41NTNsMy4yMSAzLjQ0NyAzLjIxLTMuNDQ3IDYuNTggOC40NDdoLTE5LjU3OWw2LjU4LTguNDQ3ek0xOS41MzkgMTcuMTk5bDguNDYxLTkuMDg2djE1LjY3NmwtOC40NjEtNi41OXoiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+Z2l0aHViPC90aXRsZT4KPHN0eWxlPgpzdmd7CiAgZmlsbDogd2hpdGU7Cn0KPC9zdHlsZT4KPHBhdGggZD0iTTE2IDAuMzk1Yy04LjgzNiAwLTE2IDcuMTYzLTE2IDE2IDAgNy4wNjkgNC41ODUgMTMuMDY3IDEwLjk0MiAxNS4xODIgMC44IDAuMTQ4IDEuMDk0LTAuMzQ3IDEuMDk0LTAuNzcgMC0wLjM4MS0wLjAxNS0xLjY0Mi0wLjAyMi0yLjk3OS00LjQ1MiAwLjk2OC01LjM5MS0xLjg4OC01LjM5MS0xLjg4OC0wLjcyOC0xLjg0OS0xLjc3Ni0yLjM0MS0xLjc3Ni0yLjM0MS0xLjQ1Mi0wLjk5MyAwLjExLTAuOTczIDAuMTEtMC45NzMgMS42MDYgMC4xMTMgMi40NTIgMS42NDkgMi40NTIgMS42NDkgMS40MjcgMi40NDYgMy43NDMgMS43MzkgNC42NTYgMS4zMyAwLjE0My0xLjAzNCAwLjU1OC0xLjc0IDEuMDE2LTIuMTQtMy41NTQtMC40MDQtNy4yOS0xLjc3Ny03LjI5LTcuOTA3IDAtMS43NDcgMC42MjUtMy4xNzQgMS42NDktNC4yOTUtMC4xNjYtMC40MDMtMC43MTQtMi4wMzAgMC4xNTUtNC4yMzQgMCAwIDEuMzQ0LTAuNDMgNC40MDEgMS42NCAxLjI3Ni0wLjM1NSAyLjY0NS0wLjUzMiA0LjAwNS0wLjUzOSAxLjM1OSAwLjAwNiAyLjcyOSAwLjE4NCA0LjAwOCAwLjUzOSAzLjA1NC0yLjA3MCA0LjM5NS0xLjY0IDQuMzk1LTEuNjQgMC44NzEgMi4yMDQgMC4zMjMgMy44MzEgMC4xNTcgNC4yMzQgMS4wMjYgMS4xMiAxLjY0NyAyLjU0OCAxLjY0NyA0LjI5NSAwIDYuMTQ1LTMuNzQzIDcuNDk4LTcuMzA2IDcuODk1IDAuNTc0IDAuNDk3IDEuMDg1IDEuNDcgMS4wODUgMi45NjMgMCAyLjE0MS0wLjAxOSAzLjg2NC0wLjAxOSA0LjM5MSAwIDAuNDI2IDAuMjg4IDAuOTI1IDEuMDk5IDAuNzY4IDYuMzU0LTIuMTE4IDEwLjkzMy04LjExMyAxMC45MzMtMTUuMTggMC04LjgzNy03LjE2NC0xNi0xNi0xNnoiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+cGhvbmUyPC90aXRsZT4KPHN0eWxlPgpzdmd7CiAgZmlsbDogd2hpdGU7Cn0KPC9zdHlsZT4KPHBhdGggZD0iTTIyIDIwYy0yIDItMiA0LTQgNHMtNC0yLTYtNC00LTQtNC02IDItMiA0LTQtNC04LTYtOC02IDYtNiA2YzAgNCA0LjEwOSAxMi4xMDkgOCAxNnMxMiA4IDE2IDhjMCAwIDYtNCA2LTZzLTYtOC04LTZ6Ij48L3BhdGg+Cjwvc3ZnPgo="

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI4IiB2aWV3Qm94PSIwIDAgMjQgMjgiPgo8dGl0bGU+cmVwZWF0PC90aXRsZT4KPHBhdGggZmlsbD0id2hpdGUiIGQ9Ik0yNCA0djdjMCAwLjU0Ny0wLjQ1MyAxLTEgMWgtN2MtMC40MDYgMC0wLjc2Ni0wLjI1LTAuOTIyLTAuNjI1LTAuMTU2LTAuMzU5LTAuMDc4LTAuNzk3IDAuMjE5LTEuMDc4bDIuMTU2LTIuMTU2Yy0xLjQ2OS0xLjM1OS0zLjQwNi0yLjE0MS01LjQ1My0yLjE0MS00LjQwNiAwLTggMy41OTQtOCA4czMuNTk0IDggOCA4YzIuNDg0IDAgNC43ODEtMS4xMjUgNi4zMTItMy4xMDkgMC4wNzgtMC4xMDkgMC4yMTktMC4xNzIgMC4zNTktMC4xODcgMC4xNDEgMCAwLjI4MSAwLjA0NyAwLjM5MSAwLjE0MWwyLjE0MSAyLjE1NmMwLjE4NyAwLjE3MiAwLjE4NyAwLjQ2OSAwLjAzMSAwLjY3Mi0yLjI4MSAyLjc1LTUuNjU2IDQuMzI4LTkuMjM0IDQuMzI4LTYuNjA5IDAtMTItNS4zOTEtMTItMTJzNS4zOTEtMTIgMTItMTJjMy4wNzggMCA2LjA2MiAxLjIzNCA4LjI2NiAzLjMxM2wyLjAzMS0yLjAxNmMwLjI4MS0wLjI5NyAwLjcxOS0wLjM3NSAxLjA5NC0wLjIxOSAwLjM1OSAwLjE1NiAwLjYwOSAwLjUxNiAwLjYwOSAwLjkyMnoiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(64),
  /* scopeId */
  "data-v-65fa0e4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(23)
__webpack_require__(24)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(56),
  /* scopeId */
  "data-v-11ce9cd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  "data-v-39f1157c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(22)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  "data-v-3a27412e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(65),
  /* scopeId */
  "data-v-6704b30c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(26)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-2a2c5fcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  "data-v-1422c5d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "svg__man",
      "viewBox": "0 0 500 500"
    }
  }, [_c('ellipse', {
    staticClass: "clothes",
    attrs: {
      "id": "body__man",
      "cx": "115",
      "cy": "500",
      "rx": "150",
      "ry": "200"
    }
  }), _c('path', {
    staticClass: "skin",
    attrs: {
      "id": "head__man",
      "d": "\n    M50,250\n    c0,-80 50,-150 120,-150\n    s120,50 120,150\n    c-10,80 -20,120 -100,150\n    C60,420 50,250 50,250\n  "
    }
  }), _c('path', {
    attrs: {
      "id": "ear",
      "d": "\n    M130,250\n    c-40,-10 -10,60 10,50\n  "
    }
  }), _c('g', {
    attrs: {
      "id": "g__eye_man"
    }
  }, [_c('ellipse', {
    attrs: {
      "id": "eye_w__man",
      "cx": "230",
      "cy": "205",
      "rx": "25",
      "ry": "27"
    }
  }), _c('ellipse', {
    attrs: {
      "id": "eye_ball__man",
      "cx": "238",
      "cy": "185",
      "rx": "5",
      "ry": "5"
    }
  })]), _c('g', {
    attrs: {
      "id": "g__nose_and_hand"
    }
  }, [_c('g', {
    attrs: {
      "id": "hand__man"
    }
  }, [_c('path', {
    staticClass: "skin",
    attrs: {
      "id": "finger",
      "d": "\n        M280,300\n        q7,-10 15,0\n        l0,50\n        l-15,0\n        z\n      "
    }
  }), _c('g', {
    attrs: {
      "id": "g__dig"
    }
  }, [_c('path', {
    staticClass: "skin",
    attrs: {
      "id": "palm__man",
      "d": "\n          M275,340 \n          q60,0 60,10\n          l-5,80\n          l-50,0 \n          l-10,-65\n          Q268,343 275,340\n          z\n        "
    }
  }), _c('path', {
    staticClass: "clothes",
    attrs: {
      "id": "sleeve",
      "d": "\n          M295,410\n          l40,0\n          l-5,100\n          l-55,0\n          l-5,-100\n          z\n        "
    }
  })])]), _c('path', {
    attrs: {
      "id": "blood",
      "d": "\n        M280,275\n        h15\n        v20\n        q-8,5 -15,-5\n        z\n      "
    }
  }), _c('path', {
    staticClass: "skin",
    attrs: {
      "id": "nose__man",
      "d": "\n      M280,250\n      q10,0 20,30\n      c5,0 10,20 0,20\n      l-30,0\n      q-10,-5 0,-20\n      z\n    "
    }
  })]), _c('path', {
    attrs: {
      "id": "hair__man",
      "d": "\n    M90,90\n    c100,-30 150,20 200,-20\n    c20,80 -50,120 -100,120\n    s-100,90 -150,60\n    C-30,190 50,100 90,90\n  "
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__AboutMe"
  }, [_c('header', [_c('h2', [_vm._v("- Gore Wang (王偉泰) -")])]), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', [_c('h3', [_vm._v("[ 工作經歷 ]")]), _c('p', {
    staticClass: "p_company"
  }, [_vm._v("燿麒科技")]), _c('p', [_c('span', [_vm._v("新版愛在轉角")]), _vm._v("：網站開發、")]), _c('p', [_c('span', [_vm._v("易賾單品商城")]), _vm._v("：網站開發、")]), _c('p', [_c('span', [_vm._v("韋氏中醫")]), _vm._v("：形象官網、WebVR應用開發、")]), _c('p', [_c('span', [_vm._v("愛在轉角")]), _vm._v("：網站的維護，「愛在發聲」開發、")]), _c('p', {
    staticClass: "p_company"
  }, [_vm._v("謎攻城工作室")]), _c('p', [_vm._v("企劃、製作、平面設計、網站設計、主持")]), _c('h3', [_vm._v("[ 技術分享 ]")]), _c('p', [_c('a', {
    attrs: {
      "href": "http://slides.com/gorestarry/deck-2#/"
    }
  }, [_vm._v("WebVR vs Chinese @Taipei WebGL&WebVR")])]), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=bnorojYDays&t=265s"
    }
  }, [_vm._v("Draft.js @線上React讀書會")])]), _c('p', [_c('a', {
    attrs: {
      "href": "http://slides.com/gorestarry/deck#/"
    }
  }, [_vm._v("A-Frame WebVR @Web Tech Topic")])]), _c('h3', [_vm._v("[ 長處 ]")]), _c('p', [_vm._v("擅長組織溝通、邏輯分析、問題克服＆創意實現。")]), _c('h3', [_vm._v("[ 職業能力 ]")]), _c('p', [_vm._v("對不斷變動的主流前端技術有充分自主學習意願，由於自身對視覺設計也有相關涉略，能完美接收實踐來自設計端的細節需求，更願意從工程技術面的角度來錦上添花。")]), _c('p', [_vm._v("無論效能、視覺、產品企劃，都有解決問題向前邁進的熱情與能力。")]), _c('h3', [_vm._v("[ 態度 ]")]), _c('p', [_vm._v("作為一個曾參與創業的經驗者，我能理解細節要求對於產品成敗的關鍵性。")]), _c('p', [_vm._v("所以對於工作上的要求，我絕不會被牽制在一個「我覺得沒差」的心理狀態，而願意將工作務實的做到更高的需求層級。")]), _c('h3', [_vm._v("[ 熱情 ]")]), _c('p', [_vm._v("對於實現製作好的產品有很大的熱情，樂於征服市場與使用者。")]), _c('p', [_vm._v("也會不斷自主學習新技術，並願意主動提案分享討論新技術應用方向。")])])])])])
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__Works"
  }, [_c('header'), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', _vm._l((_vm.works), function(work) {
    return _c('div', {
      staticClass: "box__work"
    }, [_c('h3', [_c('a', {
      attrs: {
        "href": work.link,
        "target": "_new"
      }
    }, [_vm._v(_vm._s(work.name))])]), _c('h4', [_vm._v("- " + _vm._s(work.technologies))]), _c('p', [_vm._v(_vm._s(work.description))])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planetOpen),
      expression: "planetOpen"
    }],
    staticClass: "box__Skills"
  }, [_c('header'), _c('div', {
    staticClass: "container__bg"
  }, [_c('section', [_c('h3', [_vm._v("Front-End：")]), _c('p', [_vm._v("【 Good 】： "), _c('span', [_vm._v("ES6、React、GSAP(GreenSock)、A-frame(WebVR)、Sass(SCSS)")])]), _c('p', [_vm._v("【 Competent 】： "), _c('span', [_vm._v("Vue.js、AngularJS(1)、Rx.js、Pug、Nightwatch、Chai、Sinon...")])]), _c('p', [_vm._v("【 Tool 】： "), _c('span', [_vm._v("Webpack、Gulp、Git、Mercurial(hg)、npm...")])]), _c('h3', [_vm._v("Back-End：")]), _c('p', [_vm._v("【 Competent 】： "), _c('span', [_vm._v("MongoDB(Mongoose)、Express、")])]), _c('p', [_vm._v("【 Limited 】："), _c('span', [_vm._v("php、MySQL、")])]), _c('h3', [_vm._v("Design：")]), _c('p', [_vm._v("【 Graphic 】："), _c('span', [_vm._v("Adobe Photoshop、Illustrator (Limited)、")])]), _c('p', [_vm._v("【 3D 】："), _c('span', [_vm._v("PTC Creo Elements/Direct、Pro/E、")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('index-component')], 1)
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_starry"
  }, [_c('div', {
    staticClass: "stars",
    attrs: {
      "id": "stars1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stars",
    attrs: {
      "id": "stars2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stars",
    attrs: {
      "id": "stars3"
    }
  })])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Cover__container"
  }, [_c('div', {
    staticClass: "wall__fill"
  }), _vm._v(" "), _c('svg-window', {
    attrs: {
      "flyFSwtich": _vm.flyFSwtich
    },
    on: {
      "zoomIn": _vm.zoomInAnimation,
      "getShock": _vm.getShockAniamtion
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wall__fill"
  }), _vm._v(" "), _c('svg-man', {
    staticClass: "cover__man",
    attrs: {
      "shockSwitch": _vm.shockSwitch
    },
    on: {
      "makeTitleFly": _vm.makeTitleFly
    }
  }), _vm._v(" "), _c('svg-computer', {
    staticClass: "cover__computer"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn__skip"
    },
    on: {
      "~click": function($event) {
        _vm.zoomInAnimation($event)
      }
    }
  }, [_vm._v("SKIP!")])], 1)
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "ship",
    attrs: {
      "viewBox": "0 0 500 500"
    },
    on: {
      "~click": function($event) {
        _vm.shakeNameplate($event)
      }
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "window__path",
      "d": "M250,125  a100,100 0 0 0 0,200 a100,100 0 0 0 0, -200z"
    }
  }), _c('path', {
    attrs: {
      "id": "text_f2e__path",
      "d": "\n    M138,220 \n    a110 106 0 1 1 224,0"
    }
  })]), _c('path', {
    staticClass: "wall",
    attrs: {
      "d": "\n          M0,0 h500 v500 h-500z\n          M250,125  a100,100 0 0 0 0,200 a100,100 0 0 0 0, -200z"
    }
  }), _c('g', {
    staticClass: "window_frame"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#window__path"
    }
  })]), _c('g', {
    staticClass: "window_screw"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#window__path"
    }
  })]), _c('text', {
    attrs: {
      "id": "text_f2e",
      "rotate": "0,0,0,0,0,0,0"
    }
  }, [_c('textPath', {
    attrs: {
      "xlink:href": "#text_f2e__path",
      "startOffset": "50%",
      "text-anchor": "middle"
    }
  }, [_vm._v("Front-End Engineer")])]), _c('g', {
    attrs: {
      "id": "g_nameplate"
    }
  }, [_c('rect', {
    staticClass: "nameplate__bg",
    attrs: {
      "x": "200",
      "y": "338",
      "rx": "10",
      "ry": "10",
      "width": "100",
      "height": "28",
      "fill": "orange"
    }
  }), _c('text', {
    staticClass: "text__name",
    attrs: {
      "x": "250",
      "y": "356",
      "text-anchor": "middle"
    }
  }, [_vm._v("Gore Wang")])])])
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "svg__computer",
      "viewBox": "0 0 400 400"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "lightGradient",
      "x1": "1",
      "x2": "0"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "white",
      "stop-opacity": "0.2"
    }
  }), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1)], 1), _c('path', {
    staticClass: "screen--rotate",
    attrs: {
      "id": "screen",
      "d": "\n    M200,200\n    l0,-150\n    l15,0\n    q20,150 0,300\n    h-15\n    z\n  "
    }
  }), _c('path', {
    attrs: {
      "id": "stand",
      "d": "\n    M210,210\n    q20,-50 80,80\n    q40,90 0,90\n    l-100,0\n  "
    }
  }), _c('rect', {
    attrs: {
      "id": "table",
      "x": "130",
      "y": "383",
      "rx": "10",
      "ry": "10",
      "width": "375",
      "height": "75"
    }
  }), _c('path', {
    staticClass: "screen--rotate",
    attrs: {
      "id": "light",
      "d": "\n    M198,41\n    l0,300\n    l-30,15\n    l0,-330\n    z\n  ",
      "fill": "url(#lightGradient)"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Index"
  }, [_c('starry-bg'), _vm._v(" "), _c('div', {
    staticClass: "box__planets",
    style: ({
      height: _vm.planetBoxHeight
    })
  }, [_c('div', {
    staticClass: "box__innerPlanets",
    style: ({
      initInnerHeight: _vm.initInnerHeight
    })
  }, _vm._l((_vm.planet_datas), function(planet, index) {
    return _c('planet', {
      key: planet.name_en,
      attrs: {
        "planetIndex": index,
        "planetOpen": _vm.planet_open,
        "name_en": planet.name_en,
        "name_zh": planet.name_zh,
        "color_planet": planet.color_planet,
        "color_planet_shadow": planet.color_planet_shadow,
        "color_name": planet.color_name
      },
      on: {
        "openPlanet": _vm.openPlanet
      }
    })
  })), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box__detail",
    style: ({
      pointerEvents: _vm.planet_open ? 'initial' : 'none'
    })
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planet_open),
      expression: "planet_open"
    }],
    staticClass: "btn__closePlanet",
    attrs: {
      "src": __webpack_require__(44),
      "alt": ""
    },
    on: {
      "click": _vm.closePlanet
    }
  }), _vm._v(" "), _c('skill-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[0].name_en,
      "planetColor": _vm.planet_datas[0].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  }), _vm._v(" "), _c('works-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[1].name_en,
      "planetColor": _vm.planet_datas[1].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  }), _vm._v(" "), _c('aboutme-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[2].name_en,
      "planetColor": _vm.planet_datas[2].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  })], 1), _vm._v(" "), (_vm.cover_mount) ? _c('svg-cover', {
    on: {
      "unmountCover": _vm.unmountCover
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__link"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sunrise91.t3@gmail.com"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(41),
      "alt": "email icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/GoreStarry"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(42),
      "alt": "github icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+886988104329"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(43),
      "alt": "phone icon"
    }
  })])])
}]}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__planet"
  }, [_c('svg', {
    staticClass: "ring ring--en",
    attrs: {
      "viewBox": "0 0 400 400"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "path__ring--en",
      "d": "M100,200a100,100 0 1,1 200,0a100,100 0 1,1 -200,0"
    }
  })]), _c('path', {
    staticClass: "stroke_assist",
    attrs: {
      "d": "M70,200a130,130 0 1,0 260,0a130,130 0 1,0 -260,0"
    }
  }), _c('path', {
    staticClass: "stroke_assist",
    attrs: {
      "stroke-dasharray": "15, 10, 5, 10, 15",
      "d": "M60,200a140,140 0 1,0 280,0a140,140 0 1,0 -280,0"
    }
  }), _c('path', {
    staticClass: "stroke_assist",
    attrs: {
      "d": "M105,200a95,95 0 1,0 190,0a95,95 0 1,0 -190,0"
    }
  }), _c('text', {
    staticClass: "text_ring text_ring--en"
  }, [_c('textPath', {
    attrs: {
      "xlink:href": "#path__ring--en",
      "startOffset": "70%",
      "text-anchor": "middle"
    }
  }, [_vm._v("| " + _vm._s(_vm.name_en) + " |")])]), _c('text', {
    staticClass: "text_ring text_ring--en"
  }, [_c('textPath', {
    attrs: {
      "xlink:href": "#path__ring--en",
      "startOffset": "20%",
      "text-anchor": "middle"
    }
  }, [_vm._v("| " + _vm._s(_vm.name_zh) + " |")])])]), _c('svg', {
    staticClass: "planet",
    attrs: {
      "x": "0px",
      "y": "0px",
      "viewBox": "0 -50 512 612"
    },
    on: {
      "mouseenter": _vm.hoverEnter,
      "mouseleave": _vm.hoverLeave,
      "click": _vm.zoomInCheck
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "path__title",
      "d": "M16,256a240,240 0 1,1 480,0a240,240 0 1,1 -480,0"
    }
  })]), _c('path', {
    style: (_vm.color_planet_style),
    attrs: {
      "d": "M434.087,256c0-256-244.87-247.185-244.87-247.185C107.153,30.91,41.403,92.802,13.92,172.52 l15.763,22.034L4.897,205.911C1.685,222.11,0,238.858,0,256c0,56.145,18.074,108.07,48.721,150.271l48.903,19.327l-19.968,14.059 c30.739,29.856,68.951,52.061,111.561,63.539C189.217,503.196,434.087,512,434.087,256z"
    }
  }), _c('polygon', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#4A8EC6"
    },
    attrs: {
      "points": "403.013,339.478 256.105,339.478 222.713,322.783 256.105,306.087 403.013,306.087 "
    }
  }), _c('rect', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#77AAD4"
    },
    attrs: {
      "x": "172.522",
      "y": "306.087",
      "width": "83.578",
      "height": "33.391"
    }
  }), _c('rect', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#4A8EC6"
    },
    attrs: {
      "x": "256.1",
      "y": "239.304",
      "width": "155.726",
      "height": "33.391"
    }
  }), _c('rect', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#A4C6E2"
    },
    attrs: {
      "x": "72.348",
      "y": "306.087",
      "width": "66.783",
      "height": "33.391"
    }
  }), _c('path', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#77AAD4"
    },
    attrs: {
      "d": "M77.651,439.652h133.931v-33.391H48.728C57.406,418.21,67.082,429.387,77.651,439.652z"
    }
  }), _c('path', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#A4C6E2"
    },
    attrs: {
      "d": "M4.909,205.913h150.918v-33.391H13.928C10.197,183.342,7.175,194.491,4.909,205.913z"
    }
  }), _c('rect', {
    staticClass: "cloud",
    staticStyle: {
      "fill": "#77AAD4"
    },
    attrs: {
      "x": "189.217",
      "y": "172.522",
      "width": "33.391",
      "height": "33.391"
    }
  }), _c('path', {
    style: (_vm.color_planet_shadow_style),
    attrs: {
      "d": "M256,0c-23.106,0-45.49,3.08-66.783,8.819C298.213,38.196,378.435,137.721,378.435,256 s-80.221,217.804-189.217,247.181C210.51,508.92,232.894,512,256,512c141.385,0,256-114.615,256-256S397.385,0,256,0z"
    }
  }), _c('text', [_c('textPath', {
    staticClass: "text__title",
    attrs: {
      "xlink:href": "#path__title",
      "startOffset": "12%",
      "text-anchor": "middle"
    }
  }, [_vm._v(_vm._s(_vm.name_en))])])])])
},staticRenderFns: []}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(40)
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[19]);


// WEBPACK FOOTER //
// static/js/app.fb7e21d26babc52e3ae7.js